<div class="w-96 h-96 p-2" [class]="direction">
  @if (!selectedMessage) {
    <app-special-messages-pop-up-list-container [messages]="combinedMessages" (onItemClicked)="selectedMessage = $event" (onClose)="closeCard()"/>
  }
  @if (selectedMessage) {
    <app-special-message-pop-up-detailed [selectedMessage]="selectedMessage" (onGoBack)="selectedMessage = null" (onClose)="closeCard()"/>
  }
</div>